import React, { useRef } from 'react'
import styled from '@emotion/styled'
import FormHeader from '../../components/FormHeader'
import FormController from '../../components/form-controller/form-controller'

export default function Page() {
  const headerRef = useRef(null)
  return (
    <OutOfZoneContainer>
      <FormHeader
        ref={headerRef}
        title={`RESERVATION\nREQUEST`}
        content={`Fill out your booking details below, and we'll do our best to accommodate your request.\n\n Out-of-zone appointments have a minimum service fee of $100, plus a travel fee based on the distance between your location and our closest zone.`}
        redirect='/out-of-zone/contact'
      />
      <FormController
        headerRef={headerRef}
        formName='out-of-zone' 
        enableAutosave={false}
      />
    </OutOfZoneContainer>
  )
}

const OutOfZoneContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  box-sizing: border-box;
`
